import React from 'react';
import styled from 'styled-components/macro';
import { Field } from 'formik';
import ConditionCreator from './ConditionCreator/ConditionCreator';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e3e5e8;
  background-color: white;
  border-radius: 4px;
  padding: 1rem;
  margin: 1rem 0;
  position: relative;
`;

const Header = styled.div`
  display: flex;
`;

const Button = styled.button<{ isActive: boolean }>`
  height: 1.7rem;
  width: 6rem;
  outline: none;
  border: none;
  background-color: ${({ isActive }) =>
    isActive ? 'rgb(31, 93, 234)' : 'transparent'} !important;
  max-width: 10rem;
  margin-right: 0.5rem;
  color: ${({ isActive }) =>
    isActive ? 'white' : 'rgb(31, 93, 234)'} !important;
  border: 1px solid rgb(31, 93, 234);
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
`;

const Content = styled.div`
  margin-top: 1rem;
`;

const Textarea = styled.textarea`
  width: 100%;
  height: 8rem;
  min-height: unset !important;
`;

const OperatorDesc = styled.div`
  font-size: 0.875rem;
`;

export type CreatorType = 'build' | 'edit';

interface Props {
  fieldName: string;
  visibleIfType?: CreatorType;
  questionsList: string[];
}

const Switcher = ({ field: { name, value }, form: { setFieldValue } }: any) => {
  return (
    <Header>
      <Button
        isActive={value === 'build'}
        onClick={() => setFieldValue(name, 'build')}
        type="button"
      >
        Build
      </Button>
      <Button
        isActive={value === 'edit'}
        onClick={() => setFieldValue(name, 'edit')}
        type="button"
      >
        Edit
      </Button>
    </Header>
  );
};

const LogicCreator = ({
  fieldName,
  visibleIfType = 'build',
  questionsList,
}: Props) => {
  const isBuildMode = visibleIfType === 'build';
  const isEditMode = visibleIfType === 'edit';
  return (
    <Container>
      <Field name={`${fieldName}.visibleIfType`} component={Switcher} />

      <Content>
        {isEditMode && (
          <>
            <Field name={`${fieldName}.visibleIf`} as={Textarea} />
            <OperatorDesc>
              <strong>Wrap each condition in brackets</strong>
              <span>{` ex ( {question1} > 22 )`} -</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>&& - </strong>
              <span>AND</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>|| - </strong>
              <span>OR</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>= - </strong>
              <span>equal</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>empty - </strong>
              <span>Empty</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>!empty - </strong>
              <span>not empty</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>contains - </strong>
              <span>contains</span>
            </OperatorDesc>
            <OperatorDesc>
              <strong>!contains - </strong>
              <span>not contains</span>
            </OperatorDesc>
          </>
        )}
        {isBuildMode && (
          <ConditionCreator
            questionsList={questionsList}
            fieldName={fieldName}
          />
        )}
      </Content>
    </Container>
  );
};

export default LogicCreator;
